import { useEffect, useState } from 'react';
import { EventDetails } from './components/EventDetails';
import { Guestlist } from './components/Guestlist';
import { ThankYou } from './components/ThankYou';

const THANKS_PATH = '/thank-you';

function isThanksPath(): boolean {
  return typeof window !== 'undefined' && window.location.pathname === THANKS_PATH;
}

export default function App() {
  const [showThanks, setShowThanks] = useState<boolean>(isThanksPath);

  // Sync component state with the browser URL via popstate so the back
  // button returns the user to the welcome + form page naturally.
  useEffect(() => {
    function onPop() {
      setShowThanks(isThanksPath());
    }
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  // If the page is loaded directly at /thank-you (e.g. user refreshed),
  // there's no submission to confirm — silently rewrite the URL to /.
  useEffect(() => {
    if (showThanks) return;
    if (window.location.pathname === THANKS_PATH) {
      window.history.replaceState({}, '', '/');
    }
  }, [showThanks]);

  function handleSubmitted() {
    window.history.pushState({}, '', THANKS_PATH);
    setShowThanks(true);
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  if (showThanks) {
    return (
      <div className="app">
        <ThankYou />
      </div>
    );
  }

  return (
    <div className="app">
      <EventDetails />
      <Guestlist onSubmitted={handleSubmitted} />
    </div>
  );
}
